module.exports = __webpack_public_path__ + "static/media/report-an-issue.66c06fe9.svg";